import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {UserProfile} from '../../../../common/user-profile.model';
import {ProjectDetailsDataService} from '../../shared/data-services/project-details.data.service';
import {UpdateRegionInfo} from '../../actions/region.action';
import {IsValidUUID} from '../../../../common/utilities/uuid';
import {Constants} from '../../shared/constants';

/**
 * Initialize Region
 * In order to support Regions, the system has been refactored to Refresh the page/app on Project Changes.
 * This refresh happens on every project change regardless of whether we are changing to the same region or to a different one.
 * This basically allows us set the Region info at he very beginning of App Init (right after the auth step)
 *
 * We are currently separate the AppInit Auth and Region steps.  If we found everything working accordingly
 * with the Init Region step, we may think about combining Auth and Region steps in the future.
 * */

@Injectable()
export class AppInitRegionService {
  constructor(private projectService: ProjectDetailsDataService, private _window: Window, private _store: Store<UserProfile>) {}
  async initializeRegion(): Promise<void> {
    const projectId = new URL(this._window.location.href).pathname.split('/')[2];
    if (!IsValidUUID(projectId)) {
      // ProjectId not in URL, nothing to do
      return Promise.resolve();
    }
    return this.projectService.RetrieveProjectRegion(projectId)
      .then((region) => {
        this._store.dispatch(UpdateRegionInfo(Constants.RegionDetails.RegionDetails[region]));
      })
      .catch(() => {
        // Note - when system failed to get Region, system shouldn't reset region to default, therefore, we just eat this error and do nothing.
        console.log(`[AppInitRegionService] - Failed to Retrieve Region Info`);
      });
  }
}
